export default __webpack_public_path__ + "static/media/wl-ico-active.76fe03a3.svg";